var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "article-wrap" }, [
    _c("div", { staticClass: "article-content" }, [
      _c("div", { staticClass: "match-category" }, [
        _c("p", [_vm._v(_vm._s(_vm.match.match_no))]),
        _vm._v(" "),
        _vm.match.isLive
          ? _c("span", { staticClass: "live_match" }, [
              _c("strong", [_vm._v("Live")]),
            ])
          : _c("span", { staticClass: "post-date" }, [
              _c("strong", [_vm._v(_vm._s(_vm.matchScheduleTime(_vm.match)))]),
            ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "venue" }, [
        _c("h4", [_c("span", [_vm._v(_vm._s(_vm.match.venue_name))])]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "teams" }, [
        _c("div", { staticClass: "team team-a" }, [
          _vm._v("\n        " + _vm._s(_vm.match.team1_name) + "\n        "),
          _vm.getTeamScore(_vm.match, _vm.match.team1_id, true)
            ? _c("span", {
                staticClass: "score",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.getTeamScore(_vm.match, _vm.match.team1_id)
                  ),
                },
              })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "team team-b" }, [
          _vm._v("\n        " + _vm._s(_vm.match.team2_name) + "\n        "),
          _vm.getTeamScore(_vm.match, _vm.match.team2_id, true)
            ? _c("span", {
                staticClass: "score",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.getTeamScore(_vm.match, _vm.match.team2_id)
                  ),
                },
              })
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.match.match_result
        ? _c("div", { staticClass: "match-date" }, [
            _c("strong", [_vm._v(_vm._s(_vm.match.match_result))]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }